export const FlameIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 17h2a2.5 2.5 0 0 0 2.5-2.5c0-1.5-.5-2-1-3-1 2-1.5 0-1.5-1C13 9 10 8 10 8c0 3-1.5 4.5-1.5 6.5z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2c0 0-5 4-5 10a7 7 0 0 0 14 0c0-2-1-4-2-5-1 2-3 3-3 3 0-3-2-5-4-8z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
